import React, { useState } from "react";
import clsx from "clsx";

import { TableRow, TableCell, Box } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import CustomDialog from "../AccessList/CustomDialog";
import { Delete } from "@material-ui/icons";
import HubbleRequests from "services/hubble";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    width: "20%",
    minWidth: "150px",
  },
  tableCellLast: {
    width: "fitContent",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.primary.main,
    height: "35px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
  status: {
    fontSize: "14px",
    marginRight: "5px",
  },
}));

const JudgeTableItem = ({ row }) => {
  const classes = useStyles();
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const dispatch = useDispatch();

  const handleDeleteJudge = () => {
    setOpenRemoveDialog(false);
    dispatch(HubbleRequests.removeJudge(row._id));
  };

  return (
    <>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {row?.owner?.fullName}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {row?.owner?.nationalCode}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellLast)}
        >
          <Box className={classes.createIconContainer}>
            <Delete color="error" onClick={() => setOpenRemoveDialog(true)} />
          </Box>
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteJudge}
      />
    </>
  );
};

export default JudgeTableItem;
